import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "wyatt-availability",
  class WyattAvailability extends WYATTElement {
    constructor() {
      super();

      this.inStore = this.querySelector("[data-in-store]");
      this.pickUp = this.querySelector("[data-pick-up]");

      this.getAvailability();

      WYATT.pubSub.subscribe(
        WYATT.pubSub.events.preferredStoreChange,
        this.getAvailability.bind(this)
      );

      WYATT.pubSub.subscribe(
        WYATT.pubSub.events.closestStoreChange,
        this.getAvailability.bind(this)
      );
    }

    async getAvailability() {
      if (!this.config.variantID) {
        this.update({
          quantityAvailable: 0,
          pickUpEnabled: false,
        });

        return;
      }

      const availabilities = await WYATT.storeAvailability.gettingAvailability(
        this.config.variantID
      );

      const availability = availabilities.find(
        ({ id }) => id === this.getStoreID()
      );

      this.update(availability);
    }

    getStoreID() {
      if (this.config.storeID) {
        return this.config.storeID;
      }

      const preferredStoreID = window.localStorage.getItem(
        WYATT.config.preferredStore.localStorageKey
      );

      if (preferredStoreID) {
        return JSON.parse(preferredStoreID);
      }

      return WYATT.user.closestStore || WYATT.shopify.stores[0].id;
    }

    update(availability) {
      this.inStore.dataset.inStore = !!availability?.quantityAvailable;
      this.pickUp.dataset.pickUp = availability?.pickUpEnabled
        ? !!availability?.quantityAvailable
        : false;
    }
  }
);
